import { languages } from '../data';

export const modifyPathPrefix = (path) => {
  let newPath = path;

  Object.keys(languages).some(
    (key) =>
      path.includes(`/${key}/`) &&
      (newPath = path.replace(`/${key}/`, `/${languages[key]}/`))
  );

  return newPath;
};

export const getModifiedPath = (path) => {
  const hasLanguagePrefix = Object.keys(languages).some((key) =>
    path.includes(`/${key}/`)
  );
  if (hasLanguagePrefix) {
    const modifiedPath = ('blog' + path).split('/');
    [modifiedPath[0], modifiedPath[1]] = [modifiedPath[1], modifiedPath[0]];
    return modifyPathPrefix(
      modifiedPath.reduce((acc, curr) => acc + '/' + curr, '')
    );
  }

  return modifyPathPrefix('/blog' + path);
};
